import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const avatarSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.avatar, {
        base: {
            root: {
                bg: 'colorPalette.muted',
            },
            fallback: {
                color: '{colors.bodyText}',
            },
        },
    }),
);
